var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3828 2.35508C21.6105 2.4902 21.75 2.7353 21.75 3V17.7273C21.75 18.0017 21.6001 18.2543 21.3591 18.3857L15.3591 21.6584C15.1353 21.7805 14.8647 21.7805 14.6409 21.6584L9 18.5816L3.35914 21.6584C3.12676 21.7852 2.84477 21.78 2.61715 21.6449C2.38953 21.5098 2.25 21.2647 2.25 21V6.27273C2.25 5.99827 2.39992 5.74573 2.64086 5.61431L8.64086 2.34158C8.86472 2.21947 9.13528 2.21947 9.35914 2.34158L15 5.41841L20.6409 2.34158C20.8732 2.21483 21.1552 2.21995 21.3828 2.35508ZM14.25 6.71795L9.75 4.26341V17.282L14.25 19.7366V6.71795ZM15.75 19.7366L20.25 17.282V4.26341L15.75 6.71795V19.7366ZM8.25 17.282V4.26341L3.75 6.71795V19.7366L8.25 17.282Z"
  })));
};
export default SvgMap;